export default [
  {
    path: "/report-center/download",
    name: "report-download",
    meta: { title: "报表中心" },
    component: () =>
      import(/* webpackChunkName: "report-download" */ "@/views/report-center/download/index.vue"),
  }
]
